import React from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";

export const ScopedLoadingOverlay: React.FC<{
  loading: boolean;
  children: React.ReactNode;
}> = ({ loading, children }) => {
  return (
    <Box sx={{ position: "relative" }}>
      {children}

      <Backdrop
        classes={{ root: "scd-loader" }}
        open={loading}
        sx={{
          position: "absolute",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        }}
      >
        <CircularProgress className="scd-loader-spinner" />
      </Backdrop>
    </Box>
  );
};
